import { useAmendmentHub } from "@xemplo/amendment-query";
import type {
  AmendmentStatusNotification,
  UseAmendmentHubOptions,
} from "@xemplo/amendment-query";

export type { AmendmentStatusNotification };

type AmendmentHubProps = {
  enabled: boolean;
  payrunId: UseAmendmentHubOptions["payrunId"];
  onStatusChanged: (notification: AmendmentStatusNotification) => void;
};

/** Thin bridge between the class-component world and the useAmendmentHub hook.
 *  Renders nothing — exists only for its SignalR subscription side-effect.
 *  Mount/unmount is controlled by the `enabled` flag from the parent. */
export function AmendmentHub({
  payrunId,
  onStatusChanged,
}: Omit<AmendmentHubProps, "enabled">) {
  useAmendmentHub({ payrunId, onStatusChanged });

  return null;
}
